
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import totales from './totales/totales.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            totales,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get ReservaEspacioAbajo()
        { return this.Controlador.Vista.BarraDebajo.Altura.Espacio; }



    }
